import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useRef, useState } from "react";
import { Button, Modal } from "./ui.js";
import { useTexts } from "./texts.js";
const ConfirmContext = createContext(null);
export function ConfirmProvider({ children }) {
    const t = useTexts();
    const [opts, setOpts] = useState(null);
    const resolver = useRef(null);
    const confirm = useCallback((o) => {
        resolver.current?.(false);
        setOpts(typeof o === "string" ? { message: o } : o);
        return new Promise((resolve) => {
            resolver.current = resolve;
        });
    }, []);
    const done = (v) => {
        resolver.current?.(v);
        resolver.current = null;
        setOpts(null);
    };
    return (_jsxs(ConfirmContext.Provider, { value: confirm, children: [children, _jsx(Modal, { open: !!opts, onClose: () => done(false), title: opts?.title ?? t.confirmTitle, width: 440, footer: _jsxs(_Fragment, { children: [_jsx("span", { className: "flex-1" }), _jsx(Button, { variant: "ghost", onClick: () => done(false), children: opts?.cancelLabel ?? t.cancel }), _jsx(Button, { variant: opts?.tone === "danger" ? "danger" : "primary", onClick: () => done(true), "data-autofocus": true, children: opts?.confirmLabel ?? t.confirmOk })] }), initialFocus: "[data-autofocus]", children: _jsx("div", { className: "text-sm leading-relaxed text-fg", children: opts?.message }) })] }));
}
/** The confirm function; falls back to window.confirm without a provider. */
export function useConfirm() {
    const ctx = useContext(ConfirmContext);
    return (ctx ??
        ((o) => Promise.resolve(window.confirm(typeof o === "string" ? o : typeof o.message === "string" ? o.message : ""))));
}
